var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "config_menu" },
    [
      _c(
        "el-form-item",
        {
          attrs: {
            prop:
              _vm.index === -1
                ? "link_type"
                : _vm.propName + "." + _vm.index + ".link_type",
            rules: [
              {
                required: true,
                message: "菜单类型不可为空",
                trigger: "change",
              },
            ],
          },
        },
        [
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { placeholder: "请选择菜单类型" },
              on: {
                change: function ($event) {
                  return _vm.onChange(_vm.value)
                },
              },
              model: {
                value: _vm.value.link_type,
                callback: function ($$v) {
                  _vm.$set(_vm.value, "link_type", $$v)
                },
                expression: "value.link_type",
              },
            },
            _vm._l(_vm.linkTypeList, function (type) {
              return _c("el-option", {
                key: type.value,
                attrs: { label: type.label, value: type.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.value.link_type + "" === "6"
        ? _c(
            "el-form-item",
            {
              attrs: {
                prop:
                  _vm.index === -1
                    ? "module_plate_id"
                    : _vm.propName + "." + _vm.index + ".module_plate_id",
                rules: [
                  {
                    required: true,
                    message: "菜单类型不可为空",
                    trigger: "change",
                  },
                ],
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: "请选择板块",
                    clearable: "",
                    filterable: "",
                  },
                  on: {
                    change: function (module_plate_id) {
                      return _vm.changeValueSaas(_vm.value, {
                        module_plate_id: module_plate_id,
                        isClear: true,
                      })
                    },
                  },
                  model: {
                    value: _vm.value.module_plate_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "module_plate_id", $$v)
                    },
                    expression: "value.module_plate_id",
                  },
                },
                _vm._l(_vm.moduleActivityList, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.value.link_type === "9"
        ? [
            _c(
              "el-form-item",
              {
                staticClass: "link_value",
                attrs: {
                  prop:
                    _vm.index === -1
                      ? "wx_appid"
                      : _vm.propName + "." + _vm.index + ".wx_appid",
                  rules: [
                    {
                      required: true,
                      message: "小程序appid不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入小程序appid", clearable: "" },
                  model: {
                    value: _vm.value.wx_appid,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "wx_appid", $$v)
                    },
                    expression: "value.wx_appid",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "link_value",
                attrs: {
                  prop:
                    _vm.index === -1
                      ? "wx_path"
                      : _vm.propName + "." + _vm.index + ".wx_path",
                },
              },
              [
                _c("el-input", {
                  attrs: { placeholder: "请输入小程序页面路径", clearable: "" },
                  model: {
                    value: _vm.value.wx_path,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "wx_path", $$v)
                    },
                    expression: "value.wx_path",
                  },
                }),
                _c("div", { staticClass: "tips" }, [
                  _c("div", [_vm._v(" 配置说明： ")]),
                  _c("div", [_vm._v(" （1）不配置页面路径默认跳转首页； ")]),
                  _c(
                    "div",
                    [
                      _vm._v(
                        " （2）配置页面路径时，若想小程序可用，不能加.htm后缀，相对路径前加/ "
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", type: "primary" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onCopy($event)
                            },
                          },
                        },
                        [_vm._v(" 复制/ ")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ]
        : [
            _c(
              "el-form-item",
              {
                staticClass: "link_value",
                attrs: {
                  prop:
                    _vm.index === -1
                      ? "link_value"
                      : _vm.propName + "." + _vm.index + ".link_value",
                  rules: [
                    {
                      required: _vm.isValueRequired(_vm.value),
                      message: "菜单链接不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                ["1", "5"].includes(_vm.value.link_type + "")
                  ? [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options:
                            _vm.value.link_type === "5"
                              ? _vm.menuListFilter
                              : _vm.menuList,
                          "collapse-tags": "",
                          props: {
                            label: "show_name",
                            value: "id",
                            children: "childrens",
                            checkStrictly: true,
                            emitPath: false,
                          },
                          filterable: "",
                          clearable: "",
                          placeholder:
                            "选择" +
                            (_vm.value.link_type === "5" ? "模块" : "菜单"),
                        },
                        on: {
                          change: function (menusid) {
                            return _vm.changeLinkValue(_vm.value, {
                              menusid: menusid,
                              isClear: true,
                            })
                          },
                        },
                        model: {
                          value: _vm.value.link_value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "link_value", $$v)
                          },
                          expression: "value.link_value",
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm.value.link_type === "2"
                  ? [
                      _c("el-input", {
                        attrs: { placeholder: "请输入链接", clearable: "" },
                        model: {
                          value: _vm.value.link_value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "link_value", $$v)
                          },
                          expression: "value.link_value",
                        },
                      }),
                    ]
                  : _vm._e(),
                _vm.value.link_type + "" === "3"
                  ? [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择子页面",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.value.link_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "link_value", $$v)
                            },
                            expression: "value.link_value",
                          },
                        },
                        _vm._l(
                          _vm.childrenMenuList,
                          function (childMenu, child_index) {
                            return _c(
                              "el-option",
                              {
                                key: child_index,
                                attrs: {
                                  label:
                                    childMenu.name + "（" + childMenu.id + "）",
                                  value: childMenu.page_unique_key,
                                  disabled: childMenu.status + "" !== "0",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(childMenu.name) +
                                      "（" +
                                      _vm._s(childMenu.id) +
                                      "）"
                                  ),
                                ]),
                                childMenu.page_used_type + "" === "1"
                                  ? _c(
                                      "span",
                                      { staticClass: "option-special-tag" },
                                      [_vm._v("专用")]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        ),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.value.link_type + "" === "4"
                  ? [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择板块",
                            clearable: "",
                            filterable: "",
                          },
                          on: {
                            change: function (menusid) {
                              return _vm.changeLinkValue(_vm.value, {
                                menusid: menusid,
                                isClear: true,
                              })
                            },
                          },
                          model: {
                            value: _vm.value.link_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "link_value", $$v)
                            },
                            expression: "value.link_value",
                          },
                        },
                        _vm._l(_vm.customerModuleList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.value.link_type + "" === "6"
                  ? [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择SaaS活动",
                            clearable: "",
                            filterable: "",
                            disabled: !_vm.value.module_plate_id,
                          },
                          model: {
                            value: _vm.value.link_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "link_value", $$v)
                            },
                            expression: "value.link_value",
                          },
                        },
                        _vm._l(_vm.activityList, function (activity) {
                          return _c("el-option", {
                            key: activity.module_activity_id,
                            attrs: {
                              label:
                                (activity.activity_hall_id
                                  ? "(" + activity.activity_hall_id + ")-"
                                  : "") + activity.title,
                              value: activity.module_activity_id,
                            },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.value.link_type + "" === "7"
                  ? [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择系统功能",
                            clearable: "",
                            filterable: "",
                          },
                          model: {
                            value: _vm.value.link_value,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "link_value", $$v)
                            },
                            expression: "value.link_value",
                          },
                        },
                        _vm._l(_vm.systemMenus, function (label, value) {
                          return _c("el-option", {
                            key: value,
                            attrs: { label: label, value: value },
                          })
                        }),
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.value.link_type + "" === "8"
                  ? [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          options: _vm.customerPackageList,
                          "collapse-tags": "",
                          props: {
                            label: "new_name",
                            value: "unique_id",
                            children: "children",
                            checkStrictly: true,
                            emitPath: false,
                          },
                          filterable: "",
                          clearable: "",
                          placeholder: "请选择礼包方案",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _c("span", [_vm._v(_vm._s(data.new_name))]),
                                  data.plan_mode + "" === "1"
                                    ? _c(
                                        "span",
                                        { staticClass: "option-promo-tag" },
                                        [_vm._v("促销")]
                                      )
                                    : _vm._e(),
                                  data.promotion_type + "" === "1"
                                    ? _c(
                                        "span",
                                        { staticClass: "option-special-tag" },
                                        [_vm._v("专用")]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4151807757
                        ),
                        model: {
                          value: _vm.value.link_value,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "link_value", $$v)
                          },
                          expression: "value.link_value",
                        },
                      }),
                      _c("div", { staticClass: "tips" }, [
                        _vm._v(
                          " 礼包分组包含启用和未启用的，选择分组未跳转时检查分组是否启用哦 "
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
      _vm.value.link_type === "1"
        ? [
            _vm.currentMenu.type === "cake" &&
            _vm.currentMenu.is_today_on + "" === "1"
              ? _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop:
                        _vm.index === -1
                          ? "is_today_on"
                          : _vm.propName + "." + _vm.index + ".is_today_on",
                    },
                  },
                  [
                    _c(
                      "el-radio-group",
                      {
                        model: {
                          value: _vm.value.is_today_on,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "is_today_on", $$v)
                          },
                          expression: "value.is_today_on",
                        },
                      },
                      [
                        _c("el-radio", { attrs: { label: "" } }, [
                          _vm._v("显示全部蛋糕商品"),
                        ]),
                        _c("el-radio", { attrs: { label: "1" } }, [
                          _vm._v("仅显示当日达商品"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        : _vm.value.link_type === "4"
        ? [
            _vm.current_module_type === "staff_library"
              ? [
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.clearBook(["book_category", "book_id"])
                            },
                          },
                          model: {
                            value: _vm.value.book_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "book_type", $$v)
                            },
                            expression: "value.book_type",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: "1" } }, [
                            _vm._v("电子书"),
                          ]),
                          _c("el-radio", { attrs: { label: "2" } }, [
                            _vm._v("有声书"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            placeholder: "请选择书籍分类（选填）",
                            clearable: "",
                            filterable: "",
                            "value-key": "id",
                          },
                          on: { change: _vm.changeBookCategory },
                          model: {
                            value: _vm.value.book_category,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "book_category", $$v)
                            },
                            expression: "value.book_category",
                          },
                        },
                        _vm._l(
                          _vm.value.book_type === "1"
                            ? _vm.eBookCategoryList
                            : _vm.aBookCategoryList,
                          function (book_c) {
                            return _c("el-option", {
                              key: book_c.id,
                              attrs: {
                                label: book_c.category_name,
                                value: book_c,
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.value.book_category
                    ? _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: "请选择指定书籍（选填）",
                                clearable: "",
                                filterable: "",
                                remote: "",
                                "remote-method": function (book_name) {
                                  return _vm.remoteBook(_vm.value, {
                                    book_name: book_name,
                                  })
                                },
                              },
                              model: {
                                value: _vm.value.book_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.value, "book_id", $$v)
                                },
                                expression: "value.book_id",
                              },
                            },
                            _vm._l(_vm.bookList, function (book) {
                              return _c("el-option", {
                                key: book.book_id,
                                attrs: {
                                  label: book.book_name,
                                  value: book.book_id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              : _vm._e(),
          ]
        : _vm.value.link_type + "" === "5"
        ? [
            _c(
              "el-form-item",
              {
                attrs: {
                  prop:
                    _vm.index === -1
                      ? "goods_id"
                      : _vm.propName + "." + _vm.index + ".goods_id",
                  rules: [
                    {
                      required: true,
                      message: "商品不可为空",
                      trigger: "change",
                    },
                  ],
                },
              },
              [
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      placeholder: "请选择商品",
                      clearable: "",
                      filterable: "",
                      remote: "",
                      "remote-method": function (name) {
                        return _vm.changeLinkValue(
                          _vm.value,
                          { menusid: _vm.value.link_value },
                          { name: name }
                        )
                      },
                      disabled: !_vm.value.link_value,
                    },
                    model: {
                      value: _vm.value.goods_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "goods_id", $$v)
                      },
                      expression: "value.goods_id",
                    },
                  },
                  _vm._l(_vm.goodsList, function (goods) {
                    return _c("el-option", {
                      key: goods.id,
                      attrs: { label: goods.goods_name, value: goods.id },
                    })
                  }),
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }